import { Add, Edit } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useFormikContext } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormProfessionals } from "../../../../actions/forms";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import { StyledCommonForms } from "../../../styled/form";

const Professional = ({
  disabled,
  fields,
  setFieldValue,
  setValuesInProfessionalModel,
  setearEspecialidadesInforme,
  professionalModel,
  handleOpenProfessional,
  handleOpenEdit,
  setEdit,
  idArt,
}) => {
  const dispatch = useDispatch();
  const { errors, touched } = useFormikContext();
  const professionals = useSelector((state) => state.forms.professionals);

  return (
    <StyledCommonForms.RowContainer>
      <FormikAutocomplete
        name="profesionalApellidoNombre"
        label={`Profesional Apellido y Nombre ${
          fields.profesionalApellidoNombre.required ? "*" : ""
        }`}
        variant="outlined"
        options={professionals.data}
        getOptions={() => dispatch(getFormProfessionals(idArt))}
        callBack={(value) => {
          setFieldValue("informacionSensible", false);
          if (!value) {
            setValuesInProfessionalModel();
            setearEspecialidadesInforme();
            setFieldValue("especialidadProfesional", "");
            return;
          }

          setValuesInProfessionalModel(value);
          if (!value.matricula || !value.especialidad) {
            setEdit(true);
            handleOpenProfessional();
            return;
          }
          setFieldValue("profesionalMnMp", value.matricula);
          setFieldValue("especialidadProfesional", value.especialidad);
          setearEspecialidadesInforme(value.nombre);
        }}
        sx={StyledCommonForms.input}
        returnProp="nombre"
        renderOption={(option) =>
          `${option.nombre} ${option.matricula ? "-" : ""} ${
            option.matricula || ""
          } ${option.nombreEspecialidad ? "-" : ""}  ${
            option.nombreEspecialidad || ""
          }`
        }
        filterOptions={(option) => option.matricula + option.nombre}
        disabled={disabled}
        error={Boolean(
          errors.profesionalApellidoNombre && touched.profesionalApellidoNombre,
        )} // Aquí pasamos el error
        helperText={
          touched.profesionalApellidoNombre && errors.profesionalApellidoNombre
        } // Y el mensaje de error
      />
      {!professionalModel.profesionalApellidoNombre ? (
        <Tooltip
          title="Agregar Profesional"
          onClick={disabled ? undefined : handleOpenProfessional}
          sx={
            disabled
              ? StyledCommonForms.addAppointmentDisabled
              : StyledCommonForms.addAppointment
          }>
          <IconButton disabled={disabled}>
            <Add />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip
          title="Editar Profesional"
          onClick={disabled ? undefined : handleOpenEdit}
          sx={
            disabled
              ? StyledCommonForms.addAppointmentDisabled
              : StyledCommonForms.addAppointment
          }>
          <IconButton disabled={disabled}>
            <Edit />
          </IconButton>
        </Tooltip>
      )}
    </StyledCommonForms.RowContainer>
  );
};

export default Professional;
